import './SearchBar.scss';

import React, { useMemo, useState } from 'react';

import { Button } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Primitives';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SearchList from './SearchList';
import { debounce } from 'lodash';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';

export default function SearchBar() {
    const { t } = useTranslation('layout');
    const [searchString, setSearchString] = useState('');
    const [localsearchAddress, setLocalSearchAddress] = useState(searchString);
    const { navigateTranslated } = usePageLocalization();

    const [isDropdowOpen, setDropdownOpen] = useState(false);
    const searchTermsDelay = useMemo(
        () => debounce(setSearchString, 500),
        [setSearchString]
    );
    return (
        <div className='search-bar'>
            <div className='search-input'>
                <input
                    className='input'
                    key={'search-input-text-box'}
                    value={localsearchAddress}
                    onChange={(event) => {
                        const searchTerm = event.target.value;
                        setLocalSearchAddress(searchTerm);
                        searchTermsDelay(searchTerm);
                        if (searchTerm.length >= 2) setDropdownOpen(true);
                        else setDropdownOpen(false);
                    }}
                    onClick={() => {
                        if (searchString.length >= 2) setDropdownOpen(true);
                    }}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter' && searchString.trim() !== '')
                            navigateTranslated(`/search/?q=${searchString}`);
                    }}
                    onBlur={() => {
                        setTimeout(() => {
                            if (isDropdowOpen) setDropdownOpen(false);
                        }, 500);
                    }}
                    placeholder={t('header.search-placeholder')}
                />
            </div>
            <Button
                className='search-button'
                onClick={() =>
                    searchString.trim() !== '' &&
                    navigateTranslated(`/search/?q=${searchString}`)
                }
            >
                <>
                    <span className='search-btn'>{t('header.search-btn')}</span>
                    <FontAwesomeIcon className='icon' icon={faSearch} />
                </>
            </Button>

            <SearchList
                searchString={searchString}
                isSearchListOpen={isDropdowOpen}
            />
        </div>
    );
}
